import React from 'react';

export interface IOrderContext {
    setCanLeave: (value: any) => void;
    canLeave: boolean;
}

export const OrderContext = React.createContext<IOrderContext | null>(null);
